export default __webpack_public_path__ + "static/media/team6.28653252.jpg";